import { IFieldsMapContainerContext, IMapContainerOptions, IMapTooltip } from "@omnia/types"
import { NutritionMap } from "../../../map/nutritionMap"
import { MapSelectInteraction } from "../map-select"
import { IDashboardContext } from "../types"
import { NutrientAppZone } from "@omnia/shared/nutrition/map/nutrientAppZone"
import { RequirementsZone } from "@omnia/shared/nutrition/map/requirementsZone"
import { ol_Feature } from "@omnia/exports/openlayers"

export class NtrDashboardMap extends NutritionMap {

    constructor(private dashboardContextProvider: () => IDashboardContext, mapContainerCtxt: IFieldsMapContainerContext, options?: IMapContainerOptions) {

        super(mapContainerCtxt, options)

        this.enableTooltips = false

    }

    protected getTooltip(tooltip: IMapTooltip): boolean {

        if (!tooltip) return false;
        if (!(tooltip.feature instanceof ol_Feature)) return false;
        if (!tooltip.contextMenu) return false;

        let ctxt = this.dashboardContextProvider();
        if (!ctxt) return false;
        if (!ctxt.enableContextMenu) return false;

        let selection = ctxt.selection;

        if (selection.planMode) return false;
        if (selection.planId && (!selection.appId)) return false;
        if ((!selection.appId) && selection.closing) return false;

        if ((tooltip.data instanceof RequirementsZone) || (tooltip.data instanceof NutrientAppZone)) {

            this.selectFeatures([tooltip.feature]);

            tooltip.context = ctxt;
            tooltip.template = "app/nutrition/dashboard.map/context-menu.html";

        }

    }

    refreshSelectInteraction() {

        if (this._select instanceof MapSelectInteraction) {

            this._select.refreshStyle()

        }
    }

}
